import Api from "../../config/api";
import {
  CREATE_CLIENT,
  SEARCH_CLIENT,
  SEARCH_CLIENT_BY_ID,
  UPDATE_CLIENT,
} from "../../utils/constants";
import { showToast } from "../toast/ShowToast";

export const getClient = async (params: any) => {
  try {
    const res = await Api(false).get(SEARCH_CLIENT, { params });
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
    } else {
      showToast(`${error?.response?.data?.message}`, "error");
    }
  }
};

export const getClientById = async (id?: string) => {
  try {
    const res = await Api(false).get(`${SEARCH_CLIENT_BY_ID}/${id}`);
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
    } else {
      showToast(`${error?.response?.data?.message}`, "error");
    }
  }
};

export const createClient = async (body: any, hideLoader: () => void) => {
  try {
    const res = await Api(false).post(CREATE_CLIENT, body);
    return res;
  } catch (error: any) {
    if (error.response.status >= 400 && error.response.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
      hideLoader();
    } else {
      showToast(`${error.response.data.message}`, "error");
      hideLoader();
    }
  }
};

export const updateClient = async (
  body: any,
  id: string,
  hideLoader: () => void
) => {
  try {
    const res = await Api(false).put(`${UPDATE_CLIENT}/${id}`, body);
    return res;
  } catch (error: any) {
    if (error.response.status >= 400 && error.response.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
      hideLoader();
    } else {
      showToast(`${error.response.data.message}`, "error");
      hideLoader();
    }
  }
};
